import { app } from '../../app.module'
app
  // アカウントの反応数グラフの表示
  .directive('accountRespond', () => {
    return {
      restrict: 'E',
      template: require('./account-respond.pug')(),
    }
  })
